import { Component, OnInit } from "@angular/core";
import { Categorie } from "../models/Categorie.model";
import { CategorieService } from "../_services/Categorie.service";
import Swal from "sweetalert2";
@Component({
  selector: "app-categorie",
  templateUrl: "./categorie.component.html",
  styleUrls: ["./categorie.component.css"],
})
export class CategorieComponent implements OnInit {
  typevetements: Categorie[];
  p: number = 1;
  constructor(private typevetementservice: CategorieService) {}

  ngOnInit() {
    this.LoadTable();
    ///////
    var pageHeader = $(".content-header").find("b");
    var adminForm = $(".admin-form");
    var buttons = adminForm.find(".button");
    var Panel = adminForm.find(".panel");
    setTimeout(function () {
      adminForm.addClass("theme-success");
      Panel.addClass("panel-success");
      pageHeader.addClass("text-success");

      buttons.removeClass().addClass("button btn-success");
    }, 800);
    //////
  }
  LoadTable() {
    this.typevetementservice.getData().subscribe((data: Categorie[]) => {
      console.log(data);
      this.typevetements = data;
      console.log(this.typevetements);
    });
  }
  delete(id) {
    this.typevetementservice.deleteData(id).subscribe(() => {
      this.LoadTable();
    });
  }
  deleteSupprimer(id){
    Swal.fire({
      title: 'Suppression',
      text: "Êtes-vous sûr de vouloir supprimer.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Non, annuler !'
    }).then((result) => {
      if (result.value) {
        this.delete(id);
        Swal.fire(
          'Supprimé!',
          'Supprimé avec succès',
          'success'
        )
      }else {

      }
    })
  }
}
